/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React                from 'react';
import { StyledIconInline } from '../StyledIconInline';


/*********************************************************************************
 2. Component
 *********************************************************************************/

const StyledIconIdeas = StyledIconInline.extend`
  height: ${props => props.height || '24px'};
  width: ${props => props.width || '23px'};
`;

export const IconIdeas = (props) => (
    <StyledIconIdeas {...props}>
        <svg viewBox="0 0 23 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
             xmlnsXlink="http://www.w3.org/1999/xlink">
            <g strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <path d="M8.9639,22.1446 C4.4909,21.2586 1.0439,17.5226 0.5949,12.9076" strokeDasharray="0,2.054"/>
                <path d="M13.0498,1.6192 C17.5228,2.5042 20.9698,6.2412 21.4188,10.8552" strokeDasharray="0,2.054"/>
                <path d="M0.5449,11.8819 C0.5449,6.1039 5.2299,1.4199 11.0069,1.4199"/>
                <path d="M21.4688,11.8819 C21.4688,17.6589 16.7848,22.3439 11.0068,22.3439"/>
                <polyline points="10.293 0.4483 11.265 1.4203 10.293 2.3913"/>
                <polyline points="11.7461 23.3155 10.7741 22.3435 11.7461 21.3725"/>
                <path d="M11.0127,13.4527 L11.0127,10.5727"/>
                <path d="M10.8633,10.9522 C10.5973,11.2082 10.0663,11.0882 9.6773,10.6842 C9.2903,10.2812 9.1903,
                9.7462 9.4573,9.4902 C9.7233,9.2342 10.2543,9.3532 10.6423,9.7572 C11.0303,10.1612 11.1303,
                10.6962 10.8633,10.9522 Z"/>
                <path d="M11.1621,10.9522 C11.4291,11.2082 11.9591,11.0882 12.3481,10.6842 C12.7361,10.2812 12.8351,
                9.7462 12.5681,9.4902 C12.3031,9.2342 11.7711,9.3532 11.3841,9.7572 C10.9951,10.1612 10.8961,
                10.6962 11.1621,10.9522 Z"/>
                <path d="M12.4102,15.3712 L12.4102,16.9742 C12.4102,17.7532 11.7792,18.3842 11.0002,18.3842 C10.2212,
                18.3842 9.5902,17.7532 9.5902,16.9742 L9.5902,15.3712"/>
                <path d="M12.4102,15.3712 C12.4102,15.3712 12.4232,14.2012 14.0082,12.6162 L14.0062,12.6162 C14.7642,
                11.8512 15.2312,10.8002 15.2312,9.6392 C15.2312,7.3022 13.3372,5.4082 11.0002,5.4082 C8.6632,
                5.4082 6.7682,7.3022 6.7682,9.6392 C6.7682,10.8002 7.2362,11.8512 7.9942,12.6162 L7.9932,
                12.6162 C9.5972,14.2192 9.5902,15.3712 9.5902,15.3712 L12.4102,15.3712 Z"/>
            </g>
        </svg>
    </StyledIconIdeas>
);



// WEBPACK FOOTER //
// ./src/components/atoms/IconIdeas/index.js